import { PreloadComponent } from '@src/core/preload.component';
import { useMemo } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { LayoutWrapperComponent } from '../layout-wrapper.component';
import useRoutes from '../routes';
import { buildEnhancedRoutes } from '../utils/route-utils';
import Error500Component from './500/error-500.component';

const RouterWrapperProvider = () => {
  const routes = useRoutes();

  const router = useMemo(
    () =>
      createBrowserRouter(
        createRoutesFromElements(
          <Route element={<PreloadComponent />} errorElement={<Error500Component />}>
            <Route element={<LayoutWrapperComponent />} errorElement={<Error500Component />}>
              {buildEnhancedRoutes(routes)}
            </Route>
          </Route>
        )
      ),
    [routes]
  );

  return <RouterProvider router={router} />;
};
export default RouterWrapperProvider;
